import { Component, DestroyRef, Inject, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface EventElement {
  id: string;
  user_name: string;
  // user_pwd: string;
  mobile: string;
  role: string;
  created_by: string;
  is_active: string;
  action: any;
}

@Component({
  selector: 'app-admin-user',
  templateUrl: './admin-user.component.html',
  styleUrls: ['./admin-user.component.scss'],
  standalone: false
})
export class AdminUserComponent {
  displayedColumns: string[] = [
    'id',
    'user_name',
    'mobile',
    // 'user_pwd',
    'role',
    'created_by',
    'is_active',
    'action',
  ];

  ELEMENT_DATA: EventElement[] = [];
  event_result: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<EventElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) { }

  ngAfterViewInit() {
    this.Get_Users();
    this.dataSource.paginator = this.paginator;
  }

  AddAdminUser() {
    const dialogRef = this.dialog.open(AddAdminUserComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Users();
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Users() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_admin_users().pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_result = data.data
        for (const item of this.event_result) {
          this.ELEMENT_DATA = this.event_result.map((item: { user_name: any; user_pwd: any; mobile: any; role: any; id: any; created_by: any, is_active: any, event_id: any; }, index: number) => ({
            srNo: index + 1,
            user_name: item.user_name,
            // user_pwd: item.user_pwd,
            mobile: item.mobile,
            role: item.role,
            id: item.id,
            created_by: item.created_by,
            is_active: item.is_active == 1 ? true : false,
            action: item.event_id
          })
          );
        }
        this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      }
    );
  }

  onCheckboxChange(element: any) {
    const isActiveValue = element.is_active ? 1 : 0;
    this.service.active_admin(element.id, isActiveValue).subscribe({
        next: (val: any) => {
          if (val.flag == true) {
            this.toastr.success(val.msg);
          } else {
            this.toastr.error(val.msg);
          }

        },
        error: (err: any) => {
          console.error(err);
        },
      });
  }

  Add_Event() {
    this.router.navigate(['/admin/Events/AddEvent']);
  }

  Edit_Event(event_id: any) {
    this.router.navigate(['/admin/Events/EditEvent', { 'event_id': event_id }]);
  }

  DeleteAdmin(id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Admin?');
    if (buttonClicked === true) {

      this.service.delete_admin_users(id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.id !== id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Admin Deleted Succesfully");
        });
    }
  }
}



@Component({
  selector: 'app-admin-user',
  templateUrl: './add-admin-user.html',
  styleUrls: ['./admin-user.component.scss'],
  standalone: false
})
export class AddAdminUserComponent {

  addUserForm: FormGroup;
  id: any
  result: any;
  hide = true;
  fname: any;
  mname: any;
  lname: any;
  role: any;
  birthdate: any;
  email: any;
  mobile: any;
  user_pwd: any;
  user_name: any;
  gender: any;
  city: any;
  state: any;
  age: any;
  volunteered_previously: any;
  skillsets: any;
  password: any;
  main: any;
  event_id: any
  private destoryRef = inject(DestroyRef);
  isResetMode = false;

  constructor(
    private member: FormBuilder,
    private adduserservice: ServicesService,
    private dialogRef: MatDialogRef<AddAdminUserComponent>,
    private toastr: ToastrService,
  ) {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.addUserForm = this.member.group({
      mobile: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(\s*\S+\s*)+$/)
      ]),
      user_pwd: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(\s*\S+\s*)+$/)
      ]),
      user_name: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(\s*\S+\s*)+$/)
      ]),
      role: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(\s*\S+\s*)+$/)
      ]),
      event_id: this.event_id
    });
  }

  // Watch for changes in mobile input
  onMobileInputChange(): void {
    console.log(this.addUserForm.value.mobile.length);

    if (this.addUserForm.value.mobile && this.addUserForm.value.mobile.length === 10) {
      this.isResetMode = false; // Reset the flag when a new 10-digit number is entered
      return this.Get_User(this.addUserForm.value.mobile); // Call the API when 10 digits are entered
    }
  }

  Get_User(mobile: string) {
    this.adduserservice.get_user_by_mobile(mobile).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
      (data: any) => {
        if (data.flag == true) {
          this.user_name = data.data[0].user_name
          this.user_pwd = data.data[0].user_pwd
          this.mobile = data.data[0].user_mobile

          console.log(this.user_pwd);
        } else {
          this.isResetMode = true
        }

      },
      error => {
        this.toastr.error('Failed to load users');
      }
    );
  }

  ngOnInit(): void {
  }

  resetPassword() {
    this.isResetMode = true;

    // Enable field
    this.addUserForm.get('user_pwd')?.enable();

    // Clear old value
    this.addUserForm.patchValue({
      user_pwd: ''
    });
  }

  onFormSubmit() {
    const formData = this.addUserForm.value;

    // ✅ Add reset flag
    formData.isResetMode = this.isResetMode;


    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.addUserForm.valid && hasNonEmptyField) {
      this.adduserservice.add_admin_users(this.addUserForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
        next: (val: any) => {
          if (val.flag == true) {
            this.toastr.success(val.msg);
          } else {
            this.toastr.error(val.msg);
          }

          this.dialogRef.close(true);
        },
        error: (err: any) => {
          console.error(err);
        },
      });
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}